import { ThemeInstance } from 'configs/theme';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  cellRoot: {
    padding: '12px 10px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    background: '#8293a3',
    color: '#fff',
  },
  tableSortRoot: {
    maxWidth: '100%',
    '&.MuiTableSortLabel-active': {
      color: '#fff',
    },
  },
  visible: {
    opacity: 1,
    marginRight: 0,
    fontSize: 'unset',
  },
  overflow: {
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  },
}));
